import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  id: "Values",
  class: "flex w-full flex-col items-center justify-start py-12"
}
const _hoisted_2 = { class: "header-flex flex min-w-[20rem] flex-col content-start items-start justify-center px-[6%] text-slate-300 xl:h-full" }
const _hoisted_3 = {
  key: 0,
  class: "material-symbols-outlined text-center text-8xl"
}
const _hoisted_4 = { class: "my-8 text-wrap text-center text-xl font-semibold text-rose-500" }
const _hoisted_5 = { class: "mx-auto w-4/5 text-center text-slate-300" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-[5%] h-1 w-4/5 rounded-full bg-slate-700 shadow-md" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_heading = _resolveComponent("sub-heading")!
  const _component_block = _resolveComponent("block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.containerStyle),
      class: "ring-offset-10 mx-16 flex max-w-screen-2xl flex-wrap items-start justify-center rounded-md bg-gray-900/90 px-12 shadow-xl ring-1 ring-slate-700 ring-offset-slate-800 backdrop-blur"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_sub_heading, { value: _ctx.title }, null, 8, ["value"]),
        _createVNode(_component_block, {
          class: "mt-2 text-left",
          value: _ctx.block
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.translationStyle),
        class: "flex flex-[0_0_22rem] flex-wrap content-start items-center justify-center transition lg:flex-[0_0_44rem] lg:justify-start"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (value, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([{ 'lg:translate-y-1/2': key % 2 > 0 }, "ring-offset-10 relative m-4 flex h-[32rem] flex-[0_0_20rem] flex-col items-center justify-start overflow-hidden rounded-md bg-slate-900 px-4 py-12 shadow-xl ring-1 ring-slate-700 ring-offset-slate-800 transition hover:z-10 hover:contrast-[1.05]"]),
            key: key
          }, [
            (value.symbol)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(value.symbol), 1))
              : _createCommentVNode("", true),
            _createElementVNode("h4", _hoisted_4, _toDisplayString(value.title), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(value.block), 1),
            _hoisted_6
          ], 2))
        }), 128))
      ], 4)
    ], 4)
  ]))
}